import { CircularProgress } from "@mui/material"

export const logo_img = 'https://storage.googleapis.com/events.makegayfriends.com/assets/makgf_logo.png'

export const Loading = () => {
    return (
        <div style={{justifyContent:'center', alignItems:'center', display:'flex', height:'100vh'}}>
            <CircularProgress />
        </div>
    )
}

export const header_radio_set = [
    "community-1.jpg",
    "community-2.jpg",
    "community-3.jpg",
    "community-4.jpg",
    "community-5.jpg",
    "community-6.jpg",
    "community-7.jpg",
    "community-8.jpg"
]

export const removeHTMLtags = (value) => value
  ?.replaceAll(/(<([^>]+)>)/ig, '')
  .replaceAll('&#39;', "'")
  .replaceAll('&quot;', '"')
  .replaceAll('&amp;', '&')
  .replaceAll('&lt;', '<')
  .replaceAll('&gt;', '>')

// For direct messages: strip Mastodon's @mention routing spans before general
// HTML removal so @handles don't appear as literal text in the bubble.
export const stripMessageContent = (html) => {
  if (!html) return ''
  return html
    .replace(/<span[^>]*class="[^"]*h-card[^"]*"[^>]*>[\s\S]*?<\/span>/gi, '')
    .replaceAll(/(<([^>]+)>)/ig, '')
    .replaceAll('&#39;', "'")
    .replaceAll('&quot;', '"')
    .replaceAll('&amp;', '&')
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .trim()
}

// Pulls real external links (not @mention/#hashtag anchors) out of Mastodon
// status HTML so callers can render them as an explicit CTA button instead of
// an inline link with Mastodon's raw, split-up URL text.
export const extractLearnMoreLinks = (html) => {
  if (!html) return { html: '', links: [] }
  const links = []
  const cleaned = html.replace(/<a\s+([^>]*)>([\s\S]*?)<\/a>/gi, (match, attrs) => {
    if (/class="[^"]*\b(mention|hashtag)\b[^"]*"/i.test(attrs)) return match
    const hrefMatch = attrs.match(/href="([^"]+)"/i)
    if (hrefMatch) links.push(hrefMatch[1])
    return ''
  })
  return { html: cleaned, links: [...new Set(links)] }
}

export const generalCategories = [
    "social",
    "wellness",
    "entertainment",
    "fashion",
    "spirituality",
    "sport_fitness",
    "travel",
    "food_dining",
    "arts_culture",
    "technology",
    "business_networking",
    "education_learning",
    "music",
    "outdoor_recreation",
    "gaming",
    "photography",
    "volunteer_community",
    "health_fitness",
    "books_literature",
    "lgbtq",
    "relationships_dating",
    "career_professional",
    "hobbies_crafts",
    "other"
]


export const header_color = "#8077FF";
export const tabBarActiveTintColor = '#ffffff';
export const tabBarActiveBackgroundColor = '#8077FF';
export const tabBarInactiveTintColor = '#9baec8';
export const tabBarInactiveBackgroundColor = '#000000';


export const pronouns = [
  'She/her',
  'She/they',
  'They/them',
  'He/they',
  'He/him',
  'Ze/hir/hirs',
  'Any',
  'Ask me',
  'Prefer not to say'
];

export const gender = [
  'Woman',
  'Man',
  'Non-Binary',
  'Gender Fluid',
  'Trans Woman',
  'Trans Man',
  'Intersex',
  'Pangender',
  'Polygender',
  'Bigender',
  'Agender',
  'Genderqueer',
  'Questioning',
  'Androgyne',
  'Neutrois',
  'Gender Non-Conforming',
  'Two-Spirit',
  'Trans Feminine',
  'Trans Masculine',
  'Womxn'
]

export const sexual_identity = [
  'Lesbian',
  'Bisexual',
  'Queer',
  'Bicurious',
  'Gay',
  'Pansexual',
  'Fluid',
  'Questioning',
  'Straight',
  'Asexual',
  'Demisexual',
  'Polysexual',
  'Flexisexual',
  'Homoflexible',
  'Heterflexible',
  'Androsexual',
  'Skoliosexual',
  'Other'
]

export const relationship_style = [
  'Monogamy',
  'Non-monogamy',
  'Polyamory',
  'Relationship anarchy',
  'Open to exploring',
  'Not sure yet',
  'Prefer not to say'
]

export const dating_goals = [
    'Hookups',
    'Something casual',
    'Casual, open to serious',
    'Serious, open to casual',
    'Serious relationship',
    'Life partner',
    'New friends',
    'Not sure yet',
    'Prefer not to say'
]

export const relationship_status = [
    'Single',
    'Coupled',
    'Married',
    'Divorced',
    'Dating',
    'Widowed',
    'Prefer not to say'
]

export const drinking = [
  'No',
  'Occasionally',
  'Socially',
  'Prefer not to say'
]

export const smoking = [
  'No',
  'Regularly',
  'Socially',
  'Prefer not to say'
]

export const political_views = [
    'Liberal',
    'Conservative',
    'Moderate',
    'Other',
    'Not political',
    'Prefer not to say'
]

export const religion = [
    'Agnostic',
    'Atheist',
    'Buddhist',
    'Christian',
    'Jewish',
    'Hindu',
    'Mormon',
    'Muslim',
    'Spiritual',
    'Churh of Hayley Kiyoko',
    'Wican',
    'Other',
    'Not religious',
    'Prefer not to say'
]

export const diet = [
    'Vegetarian',
    'Vegan',
    'Pescatarian',
    'Gluten-free',
    'Kosher',
    'I eat everything',
    'Vagotarian',
    'Other',
    'Prefer not to say'
]

export const star_sign = [
    'Capricorn',
    'Aquarius',
    'Pisces',
    'Aries',
    'Taurus',
    'Gemini',
    'Cancer',
    'Leo',
    'Virgo',
    'Libra',
    'Scorpio',
    'Sagittarius',
    'Prefer not to say'
]

export const pets = [
    'Dogs',
    'Cats',
    'Tons of cats',
    'Other pets',
    'Love animals, but no pets',
    'Not an animal person',
    'Perfer not to say'
]

export const family_perferences = [
    'Have kids',
    'Want someday',
    "Don't want",
    'Not sure yet',
    'Prefer not to say'
]

export const intimacy_preferences = [
    'Cuddling',
    'Emotional Attachment',
    'Eye Gazing',
    'Feeling Seen',
    'Holding Hands',
    'Making Out',
    'Massage',
    'Sensual Touch'
]